import { IChangeDisplayNameRequest } from "api/models/request/IChangeDisplayNameRequest";
import { changeDisplayName } from "api/services/user-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { useCallback } from "react";

export const useChangeDisplayName = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IChangeDisplayNameRequest, any>(changeDisplayName, 'profile.changeDisplayNameSuccess', 'profile.changeDisplayNameError');
    
    const changeDisplayNameMethod = useCallback(async (newDisplayName: string, userId: string | undefined) => {
        const resp = await callAPI({ newDisplayName, userId });
        return resp;
    }, [callAPI]);

    return { changeDisplayName: changeDisplayNameMethod, changeDisplayNamePending: loading }
}